import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

export function useNonce() {
  const ref = useRef(uuid());
  return ref.current;
}
